import React from 'react';
import { Create, SimpleForm, TextInput } from 'react-admin';

export const CategoryCreate = () => (
  <Create title="Create category" redirect="list">
    <SimpleForm>
      <TextInput source="name" label="Name" required />
      <TextInput source="description" label="Description" required />
    </SimpleForm>
  </Create>
);

